<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="value"
        :label="label"
        :hint="hint"
        :placeholder="hint"
        prepend-icon="mdi-calendar"
          color="#27e96a"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
     color="#27e96a"
      header-color="#000"
      :min="minDate"
      :value="value"
      @input="changeDate"
    ></v-date-picker>
  </v-menu>
</template>
<script>
export default {
  props: {
    label: String,
    value: String,
    hint: String,
    minDate: String,
  },
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    changeDate(val) {
      this.menu = false;
      this.$emit("input", val);
    },
  },
};
</script>
<style lang="scss">
